export const HANDLE_PREFIX = '@';

export enum SOCIAL_PLATFORMS_CONNECTION_STATUS {
  connected = 'connected',
  connectionExpired = 'connectionExpired',
  disconnected = 'disconnected',
  invalid = 'invalid',
  loading = 'loading',
  offPlatform = 'off-platform',
  manual = 'manual',
}

export enum SOCIAL_PLATFORMS {
  instagram = 'instagram',
  tiktok = 'tiktok',
  youtube = 'youtube',
}

export enum PARTIALLY_SUPPORTED_PLATFORMS {
  snapchat = 'snapchat',
}

export const ALL_SOCIAL_PLATFORMS = {
  ...SOCIAL_PLATFORMS,
  ...PARTIALLY_SUPPORTED_PLATFORMS,
};
export type ALL_SOCIAL_PLATFORM_TYPE =
  (typeof ALL_SOCIAL_PLATFORMS)[keyof typeof ALL_SOCIAL_PLATFORMS];

export enum SOCIAL_PLATFORMS_NAMES {
  instagram = 'Instagram',
  facebook = 'Facebook',
  youtube = 'YouTube',
  tiktok = 'TikTok',
  twitter = 'Twitter',
  snapchat = 'Snapchat',
}
export type SOCIAL_PLATFORM_SHORT = 'IG' | 'TT' | 'YT' | 'SC';

const TIKTOK_CONTENT_TYPE = 'tiktok';
const YOUTUBE_CONTENT_TYPE = 'youtube';

export enum INSTAGRAM_CONTENT_TYPES {
  story = 'story',
  post = 'post',
  reels = 'reels',
}

/**
 * TODO: At the moment `SOCIAL_PLATFORMS_ENABLED_FOR_MEDIAPACKS` is a fixed
 * constant, but the idea is to have an `useEnabledSocialPlatforms` hook if
 * we start using feature flags, so this would just return an array of keys
 * of the SOCIAL_PLATFORMS currently globally enabled
 * (for mediapacks or whatever) in the running environment.
 */
export const SOCIAL_PLATFORMS_ENABLED_FOR_MEDIAPACKS = [
  SOCIAL_PLATFORMS.instagram,
  SOCIAL_PLATFORMS.tiktok,
  SOCIAL_PLATFORMS.youtube,
];

export const CONTENT_TYPES = {
  ...INSTAGRAM_CONTENT_TYPES,
  [TIKTOK_CONTENT_TYPE]: TIKTOK_CONTENT_TYPE,
  [YOUTUBE_CONTENT_TYPE]: YOUTUBE_CONTENT_TYPE,
} as const;

export const PRIMARY_SOCIAL_PLATFORMS = [
  SOCIAL_PLATFORMS.instagram,
  SOCIAL_PLATFORMS.tiktok,
] as const;

export const SOCIAL_PLATFORMS_REMINDER_DAYS: number = 3;

export type SupportedPlatforms =
  | SOCIAL_PLATFORMS.instagram
  | SOCIAL_PLATFORMS.tiktok
  | SOCIAL_PLATFORMS.youtube
  | PARTIALLY_SUPPORTED_PLATFORMS.snapchat;

export const BASE_SUPPORTED_PLATFORMS = [
  SOCIAL_PLATFORMS.instagram,
  SOCIAL_PLATFORMS.tiktok,
  SOCIAL_PLATFORMS.youtube,
] as const satisfies readonly SupportedPlatforms[];

export type SupportedCharts = 'age' | 'gender' | 'country' | 'growthRate';
